import { render } from "./AppHeader.vue?vue&type=template&id=63b713b0"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"
script.render = render

export default script